"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmation_glue = void 0;
const tslib_1 = require("tslib");
const MethodManager_1 = require("../../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
class confirmation_glue {
    // Initialize when listview is databound
    static init(viewObject) {
        // Init radiobuttons changed event
        let confInstances = $(".confObject");
        confInstances.find("input.bestgSelect").change(function () {
            let $this = $(this);
            let best = $this.attr("data-best");
            let parentConfObject = $(this).closest(".confObject");
            confirmation_glue.enableButtonBar(parentConfObject, best);
        });
        confInstances.each(function (idx, elem) {
            let firstRadioButton = $(elem).find(".confObjects").find("li:first-child").find(".bestgSelect");
            if (firstRadioButton.length)
                firstRadioButton.attr("checked", "checked").trigger("change");
            else {
                let $confObj = $(this).closest(".confObject");
                confirmation_glue.enableButtonBar($confObj, undefined);
            }
        });
        // Init actionbutton click events
        confInstances.find(".confirmActionButton")
            .off("click")
            .on("click", function (e) {
            let btn = $(this);
            let action = btn.attr("data-action"), target = btn.attr("data-target"), confObjectId = btn.attr("data-confobject");
            MethodManager_1.MethodManager.executeMethod("cemanagsys.29", [target], undefined, 0, function () {
                viewObject.reloadData();
                Utilities_1.synUtil.Notifications.menuSuccess("cemanagsys.29");
            }, {
                selectedOption: action,
                confObjectId,
            });
            e.stopPropagation();
        });
        confInstances.find(".btn.preview").on("click", function () { viewObject.showPreview($(this).attr("data-id")); });
        let toggleCollapse = function (e, $this) {
            let $confObj = $this.closest(".confObject");
            let btn = $confObj.find(".btn-attachments");
            let attachmentList = $confObj.find(".attachments");
            if (btn.hasClass("collapsed")) {
                btn.removeClass("collapsed");
                attachmentList.removeClass("collapse");
            }
            else {
                btn.addClass("collapsed");
                attachmentList.addClass("collapse");
            }
            e.stopPropagation();
        };
        // initalize attachment expand/collapse button
        confInstances.find(".btn-attachments")
            .off("click")
            .on("click", function (e) { toggleCollapse(e, $(this).closest(".confObject")); });
        // If document to confirm has no content but attachments, instead of attempting to fetch the content,
        // expand the attachments list.
        $.each(viewObject.dataSource.data(), function (idx, dataElem) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let $titleLink = $(".confObject[data-id='" + dataElem.DocumentToConfirm.id + "']").find("a.title");
                if (!dataElem.HasContent && dataElem.Attachments.length) {
                    $titleLink
                        .addClass("noContent")
                        .on("click", function (e) {
                        toggleCollapse(e, $(this));
                        e.preventDefault();
                    });
                }
            });
        });
    }
    static enableButtonBar(parentConfObject, bestId) {
        parentConfObject.find(".buttonBar").css("display", "none");
        if (bestId)
            parentConfObject.find(".buttonBar[data-best='" + bestId + "']").css("display", "");
        else // only one confirmation object: enable the only button bar.
            parentConfObject.find(".buttonBar").css("display", "");
    }
}
exports.confirmation_glue = confirmation_glue;
